import React, { useState, useEffect } from "react";
import { IconButton, Typography, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from "@mui/icons-material/Business";
import InputField from "../../../components/InputField/InputField";
import Button from "../../../components/Button/Button";
import Modal from "../../../components/Modal/Modal";
import {
  StyledDialog,
  StyledDialogTitle,
  StyledDialogContent,
  HeaderContainer,
  FormContainer,
  ButtonGroup,
  IconContainer,
  GridContainer,
} from "./AddClientDesignationStyles";
import { useLoading } from "../../../contexts/LoadingContext";

const AddClientDesignation = ({
  open,
  onClose,
  initialData = null,
  onSubmit,
}) => {
  const isEdit = !!initialData;
  const initialFormState = {
    client_designation_name: "",
  };

  const [formData, setFormData] = useState(initialFormState);
  const [errorModal, setErrorModal] = useState(null);
  const { showLoading, hideLoading } = useLoading();

  useEffect(() => {
    if (open) {
      if (initialData) {
        setFormData({
          client_designation_name: initialData.client_designation_name || "",
        });
      } else {
        setFormData(initialFormState);
      }
    } else {
      setFormData(initialFormState);
    }
    setErrorModal(null);
  }, [initialData, open]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDropdownChange = (field) => (value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorModal(null);

    try {
      showLoading();
      console.log("formData", formData);
      await onSubmit({
        ...formData,
      });
      setFormData(initialFormState);
    } catch (error) {
      setErrorModal({
        type: "error",
        title: "Action Failed",
        message: error.message || "Something went wrong",
      });
    } finally {
      hideLoading();
    }
  };

  const handleClose = () => {
    setFormData(initialFormState);
    setErrorModal(null);
    onClose();
  };

  const handleErrorModalClose = () => {
    setErrorModal(null);
  };

  return (
    <>
      <StyledDialog open={open} onClose={handleClose} maxWidth="md">
        <StyledDialogTitle>
          <HeaderContainer>
            <IconContainer>
              <BusinessIcon />
              <Typography variant="h6">
                {isEdit
                  ? "Edit Client Designation Details"
                  : "Add New Client Designation"}
              </Typography>
            </IconContainer>
            <IconButton onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </HeaderContainer>
        </StyledDialogTitle>

        <FormContainer onSubmit={handleSubmit}>
          <StyledDialogContent>
            <GridContainer container spacing={2.5}>
              <Grid item xs={6}>
                <InputField
                  label="Client Designation Name"
                  name="client_designation_name"
                  value={formData.client_designation_name}
                  onChange={handleInputChange}
                  required
                  fullWidth
                  placeholder="Enter client Designation name"
                />
              </Grid>
            </GridContainer>

            <ButtonGroup>
              <Button
                variant="outlined"
                onClick={handleClose}
                fullWidth={false}
              >
                Cancel
              </Button>
              <Button type="submit" variant="contained" fullWidth={false}>
                {isEdit
                  ? "Update Client Designation"
                  : "Add Client Designation"}
              </Button>
            </ButtonGroup>
          </StyledDialogContent>
        </FormContainer>
      </StyledDialog>

      {errorModal && (
        <Modal
          type={errorModal.type}
          title={errorModal.title}
          message={errorModal.message}
          onClose={handleErrorModalClose}
        />
      )}
    </>
  );
};

export default AddClientDesignation;
